import Vue from 'vue'
import PrismicVue from 'prismic-vue'
import Meta from 'vue-meta';
import linkResolver from './prismic/link-resolver'
import htmlSerializer from './prismic/html-serializer'
import App from './App.vue'
import VueAnalytics from 'vue-analytics'
import router from './router'
import jQuery from 'jquery'
global.jQuery = jQuery
global.$ = jQuery

let scripts = require('./assets/js/benjaminpontinen.js')

Vue.config.productionTip = false

Vue.use(PrismicVue, {
  endpoint: window.prismic.endpoint,
  linkResolver,
  htmlSerializer
})

Vue.use(Meta)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');


Vue.use(VueAnalytics, {
  id: 'UA-140030250-1',
  router
})
